<template>
  <div>
    <conference-entry
        v-for="conference in activities"
        :conference="conference"
        :key="conference.id"
        :show-description="showDescription"
    />
    <p v-if="activities.length === 0" style="text-align: center">Aucune conférence pour le moment.</p>
  </div>
</template>

<script>
  import ConferenceEntry from './Conference';
  import { mapGetters, mapActions } from 'vuex';
  import _ from 'lodash';

  export default {
    name: 'conferences-list',
    components: { ConferenceEntry },
    props: {
      limit: {
        type: Number,
        default: () => null
      },
      showDescription: {
        type: Boolean,
        default: () => true
      }
    },
    async mounted() {
      await this.fetchConferences();
    },
    computed: {
      ...mapGetters('services', {
        _conferences: 'conferences'
      }),
      activities() {
        let conferences = this._conferences;
        if (!conferences) {
          return conferences;
        }
        conferences = _.sortBy(conferences, a => a.date);
        if (_.isNumber(this.limit)) {
          conferences = _.slice(conferences, 0, this.limit);
        }
        return conferences.filter(c => c.show !== false);
      }
    },
    methods: {
      ...mapActions('services', {
        fetchConferences: 'fetchServices'
      })
    }
  };
</script>

<style scoped></style>
